module.exports = __webpack_public_path__ + "static/media/email-popup.aaae4aa4.png";